'use client';

import { SmartInput } from '@web/ui';

import type { JobStatus } from '@/features/jobs/types';

type JobStatusFilter =
  | 'all'
  | Extract<JobStatus, 'active' | 'completed' | 'archived'>;

type JobStatusSelectFieldProps = {
  value: string;
  onChange: (value: JobStatusFilter) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  error?: string;
  size?: 'small' | 'medium';
};

const JOB_STATUS_OPTIONS: { value: JobStatusFilter; label: string }[] = [
  { value: 'all', label: 'All statuses' },
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'archived', label: 'Archived' },
];

export function JobStatusSelectField({
  value,
  onChange,
  label = 'Job Status',
  name = 'job-status',
  disabled = false,
  error,
  size = 'small',
}: JobStatusSelectFieldProps) {
  return (
    <SmartInput
      type="select"
      name={name}
      label={label}
      size={size}
      value={value || 'all'}
      options={JOB_STATUS_OPTIONS}
      readOnly={disabled}
      error={error}
      onChange={(nextValue) => onChange(nextValue as JobStatusFilter)}
    />
  );
}
